import React from 'react';
import {
  SideNav,
  UserRolesText,
  AddUserRole,
  AddUserRoleButton,
  UserRolesHeader,
  UserRole,
  UserRoleContainer,
} from '@app/modules/user-roles/user-roles-component';
import { Button } from '@app/components';
import { SelectedRoleProps } from '@app/types';

type Props = {
  userRoles: any;
  addUserRole: () => void;
  setSelectedRole: any;
  selectedRole: SelectedRoleProps;
  isMobile: boolean;
};

type UserRole = {
  _id: string;
  name: string;
  description: string;
};
const UserRolesSidenav = ({
  userRoles,
  addUserRole,
  setSelectedRole,
  selectedRole,
  isMobile,
}: Props) => {
  return (
    <>
      <SideNav>
        <UserRolesHeader>
          <AddUserRole>
            <UserRolesText>
              User Roles ({userRoles && userRoles.length ? userRoles.length : 0}
              )
            </UserRolesText>
            <AddUserRoleButton>
              <Button onClick={() => addUserRole()} variant="primary">
                + Add Role
              </Button>
            </AddUserRoleButton>
          </AddUserRole>
        </UserRolesHeader>
        <UserRoleContainer>
          {userRoles && userRoles.length
            ? userRoles.map((userRole: UserRole, index: number) => {
                return (
                  <UserRole
                    selected={
                      !isMobile && selectedRole.name === userRole.name
                        ? true
                        : false
                    }
                    key={index}
                    onClick={() =>
                      setSelectedRole({ id: userRole._id, name: userRole.name })
                    }>
                    {userRole.name}
                  </UserRole>
                );
              })
            : null}
        </UserRoleContainer>
      </SideNav>
    </>
  );
};

export default UserRolesSidenav;
